import {useShopId} from '@aboutyou/config';
import React, {useCallback} from 'react';
import {useTrackFeature} from '../trackingHooks/useTrackFeature';
import {BaseTracker} from './BaseTracker';

export const TrackInternationalPopupImpression: React.FC<
  React.PropsWithChildren<{
    className?: string;
  }>
> = ({children, className}) => {
  const trackFeature = useTrackFeature();
  const shopId = useShopId();

  const handleImpressionTracking = useCallback(
    (type: 'impression' | 'click') => {
      if (type === 'impression') {
        trackFeature({
          eventType: 'impression',
          label: 'international_url_pop_up',
          value: shopId,
        });
      }
    },
    [trackFeature, shopId],
  );

  return (
    <BaseTracker
      threshold={0}
      track={handleImpressionTracking}
      className={className}
      data-testid="internationalPopupObserver"
    >
      {children}
    </BaseTracker>
  );
};
